import api from '@/api/locales';

export default {
    state: {
        locales: null,
    },
    getters: {
        getCurrentLocale: (state) => (locale) => state.locales && state.locales.filter(item => item.code === locale)[0]
    },
    mutations: {
        SET_LOCALE_DATA(state, payload) {
            var locales = [];

            for (var i in payload) {
                locales.push({
                    code: i,
                    text: payload[i]
                });
            }
            state.locales = locales;
        },
    },
    actions: {
        fetchLocales({
            commit,
            dispatch,
        }) {
            dispatch('setIsLoadingData', true);
            api.get().then(({
                data: {
                    data: {
                        locales
                    }
                }
            }) => {
                commit('SET_LOCALE_DATA', locales);
            }).finally(() => {
                dispatch('setIsLoadingData', false);
            });
        },
        postLocale({
            dispatch
        }, payload) {
            dispatch('setIsLoadingData', true);
            api.post(payload).then(({
                status
            }) => {
                if (status === 200) {
                    window.localStorage.setItem('locale', payload);
                    window.location.reload();
                }
            }).finally(() => {
                dispatch('setIsLoadingData', false);
            })
        }
    },
};